module.exports = __webpack_public_path__ + "img/category-sport-hover.feb25c6d.png";